import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_PROCESS} from '../../metamodel/Concept';

export default class BusinessProcessNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_PROCESS;
	}
}
